import { createFileRoute } from "@tanstack/react-router";
import { ExpenseCategoryModals } from "@/components/expense-category/expense-category-modals";
import { DeleteFinanceCategoryModal } from "@/components/finance-category/finance-category-modals/delete-finance-category-modal";
import { IncomeCategoryTableColumns } from "@/components/income-category/income-category-meta";
import FullPagination from "@/components/ui/shared/full-pagination";
import { SearchEngine } from "@/components/ui/shared/search-engine";
import { Button } from "@/components/ui/button";
import SimpleTable from "@/components/ui/table";
import { useSimpleForm } from "@/hooks/use-simple-form";
import useAppStore from "@/store";
import { Banknote, Plus } from "lucide-react";
import { useEffect } from "react";
import { useTranslate } from "@/hooks/use-translate";

export const Route = createFileRoute("/(dasboard)/finance/expense-categories")({
  component: ExpenseCategoriesPages,
});

function ExpenseCategoriesPages() {
  const store = useAppStore();
  const { t } = useTranslate();

  const searchForm = useSimpleForm({
    keyword: "",
  });

  const search = ({ page = 1, per_page = 10 } = {}) => {
    store.financeCategory.fetch({
      page,
      per_page,
      ...searchForm.values,
      type: "expense",
    });
  };

  useEffect(() => {
    if (store.auth.session) {
      search();
      store.ohadaCode.fetch({ type: "expense" });
    }
  }, [store.auth.session]);

  return (
    <>
      <ExpenseCategoryModals />
      <DeleteFinanceCategoryModal />

      <div className="max-w-7xl mx-auto">
        <header className="flex items-center justify-between mb-4">
          <h2 className="text-xl font-semibold"> {t("Expense categories")} </h2>
          <Button
            onClick={() => {
              store.display.show("create_expense_category");
            }}
          >
            <Plus className="w-4 h-4" />
            {t("Add a category")}
          </Button>
        </header>

        <SearchEngine
          autoComplete={(values: any) => {
            store.financeCategory.paginate(
              store.financeCategory.items.filter(
                (fc: any) =>
                  fc.title
                    .toLowerCase()
                    .includes(values.keyword.toLowerCase()) &&
                  (values.type ? values.type == fc.type : true) &&
                  (values.ohada_code_id
                    ? values.ohada_code_id == fc.ohada_code_id
                    : true)
              )
            );
          }}
          form={searchForm}
          onSubmit={undefined}
          selects={[
            {
              placeholder: t("All OHADA codes"),
              options: store.ohadaCode.items.map((item) => ({
                value: item.id,
                label: `${item.id} ${item.title}`,
              })),
              name: "ohada_code_id",
              icon: <Banknote className="w-4 h-4" />,
              size: "w-[400px]",
            },
          ]}
        />

        <SimpleTable
          items={store.financeCategory.pagination.data}
          columns={IncomeCategoryTableColumns({
            onEdit: (category: any) => {
              store.financeCategory.setCurrent(category);
              store.display.show("edit_expense_category");
            },
            onDelete: async (category: any) => {
              store.financeCategory.setCurrent(category);
              store.display.show("delete_finance_category");
            },
          })}
        />

        <FullPagination
          className="mt-4"
          canEdit={true}
          pagination={store.financeCategory.pagination}
          onGoto={(page) => search({ page })}
          onPerPage={(per_page) => search({ per_page })}
        />
      </div>
    </>
  );
}
